<template>
  <div>
    <h1 class="view-title mb-12 text-center">{{ params.title }}</h1>

    <div class="text-center mb-16" v-if="params.lead" v-html="params.lead"></div>

    <v-row>
      <v-col v-if="params.img" :cols="4">
        <div class="pa-5 text-center">
          <img :src="params.img.src" class="oval-frame mb-6">
          <small v-if="params.img.title">{{ params.img.title }}</small>
        </div>
      </v-col>
      <v-col :cols="params.img ? 8 : 12" class="d-flex align-center" fill-height>
        <component :is="{ components: { PinchZoom }, template: params.content }"></component>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PinchZoom from 'vue-pinch-zoom';
export default {
  props: ['params'],
  data() {
    return {
      PinchZoom
    };
  }
}
</script>

<style lang="scss" scoped>
.image {
  width: 100%;
  height: auto;
  margin: 18px;
}

.__vuescroll {
  max-height: calc(100vh - 420px);
  margin-right: -16px !important;

  div {
    overflow: auto;
  }

  & > .__panel {
    padding-right: 16px !important;
  }
}
</style>
